import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';

export default function ScoreSubmissionForm({ duel, user, onSubmit, isLoading }) {
    const [attackerScore, setAttackerScore] = useState('');
    const [defenderScore, setDefenderScore] = useState('');
    const [error, setError] = useState(null);

    const isAttacker = user.id === duel.attacker_user_id;

    const handleSubmit = () => {
        if (attackerScore === '' || defenderScore === '') {
            setError('Veuillez entrer les deux scores');
            return;
        }

        const aScore = parseInt(attackerScore);
        const dScore = parseInt(defenderScore);

        if (isNaN(aScore) || isNaN(dScore) || aScore < 0 || dScore < 0) {
            setError('Les scores doivent être des nombres positifs');
            return;
        }

        setError(null);
        onSubmit({ attacker_score: aScore, defender_score: dScore });
    };

    return (
        <Card className="bg-[#13151D] border-2 border-[#6E2BFF] p-5 space-y-4">
            <p className="text-sm font-black uppercase tracking-wider text-[#6E2BFF] text-center">
                📊 Soumettre le Score final
            </p>
            <div className="flex gap-3 items-center">
                <div className="flex-1">
                    <label className="text-xs text-[#B3B6C2] font-semibold uppercase tracking-wider block mb-2">
                        {duel.attacker_name}
                    </label>
                    <Input
                        type="number"
                        min="0"
                        value={attackerScore}
                        onChange={(e) => setAttackerScore(e.target.value)}
                        placeholder="0"
                        disabled={isLoading}
                        className="bg-[#1B1E28] border-[#6E2BFF]/30 text-white text-center text-2xl font-black h-16 focus:border-[#6E2BFF]"
                    />
                </div>
                <div className="text-center pt-6 font-black text-[#6E2BFF] text-2xl">-</div>
                <div className="flex-1">
                    <label className="text-xs text-[#B3B6C2] font-semibold uppercase tracking-wider block mb-2">
                        {duel.defender_name}
                    </label>
                    <Input
                        type="number"
                        min="0"
                        value={defenderScore}
                        onChange={(e) => setDefenderScore(e.target.value)}
                        placeholder="0"
                        disabled={isLoading}
                        className="bg-[#1B1E28] border-[#6E2BFF]/30 text-white text-center text-2xl font-black h-16 focus:border-[#6E2BFF]"
                    />
                </div>
            </div>
            {error && (
                <p className="text-sm text-red-400 text-center bg-red-500/10 p-2 rounded border border-red-500/30">
                    {error}
                </p>
            )}
            <Button
                className="w-full bg-[#6E2BFF] hover:bg-[#8B5CFF] text-white font-bold text-sm uppercase transition-all shadow-lg hover:shadow-lg hover:shadow-[#6E2BFF]/40"
                onClick={handleSubmit}
                disabled={isLoading}
            >
                {isLoading ? 'Envoi...' : '✓ Soumettre le Score'}
            </Button>
        </Card>
    );
}